<script setup>
import { ref, onMounted } from "vue";

const igUrl = "https://www.instagram.com/ryumuraki3/";

const albums = [
  {
    id: "playin-the-hero",
    title: "Playin' The Hero",
    catalogNumber: "YRCD-044",
    label: "Yokohama Reunion",
    releaseDate: "2023.11",
    image: require("../../assets/images/work/playing_the_hero.png"),
    price: "¥2,000",
    tracklist: [
      "Slipped Disc",
      "Limehouse Blues",
      "Body And Soul",
      "Honey Suckle Rose*",
      "Nice Work If You Can Get It",
      "If I Had A Ribbon Bow",
      "I Got Rhythm",
      "Tea For Two",
      "Sweet Lorraine*",
      "Avalon*",
      "Caravan",
      "Memories of You",
      "China Boy",
    ],
    note: "＊は一部楽曲を除くCD限定収録曲",
    description: [
      "3人にとっての全ての始まり、音楽のヒーローへの憧れが詰まった1st.アルバム。珠玉のジャズ・スタンダード13曲を収録。",
      "ライブ会場のほか、Yokohama Reunionオンラインストア、各種ストリーミングサービスにて配信中。",
    ],
    credits: ["Artwork: @yasutakapollon @bandy_photo_ @chitotong"],
    links: [
      {
        label: "配信で聴く",
        url: "https://linktr.ee/Playin_The_Hero",
      },
      {
        label: "CDを購入",
        url: "https://yokohamareunion.art/products/playin-the-hero",
      },
    ],
  },
  {
    id: "ryu-muraki-three",
    title: "Ryu Muraki Three",
    catalogNumber: "SA001",
    label: "S.Activities",
    releaseDate: "2026.3.21",
    image: require("../../assets/images/work/rm3_2nd_album.jpg"),
    price: null,
    tracklist: [
      "Railroad Maintenance",
      "Wrong Corner To The Right",
      "The Gloom One Step Ahead",
      "Tiger Rag",
      "Lanterns And Ripples",
      "The Mouse On The Roof",
      "I Remember Tom",
      "The Five Pennies",
      "But Be Careful",
      "Blues On Wednesday",
      "Early Birds And Night Owls",
    ],
    note: "",
    description: [
      "メンバーのオリジナル楽曲を中心に収録した、3人の追求する音楽の現在地であり、その姿勢を体現するセルフタイトル・アルバム。",
    ],
    credits: [
      "Clarinet: 村木龍 Ryu Muraki (@clarinet_ryu)",
      "Piano: 市川空 Sora Ichikawa (@sora.ichikawa)",
      "Drums: 海老原颯 So Ebihara (@chitotong)",
      "Engineer: 市川豪人 Taketo Ichikawa",
      "Artwork: 小林靖享 Yasutaka Kobayashi",
    ],
    links: [
      {
        label: "配信で聴く",
        url: "https://ultravybe.lnk.to/Ryumurakithree",
      },
      {
        label: "Bandcampを見る",
        url: "https://ryumuraki.bandcamp.com/album/ryu-muraki-three",
      },
    ],
  },
  {
    id: "handful-of-keys",
    title: "Handful of Keys",
    catalogNumber: "",
    label: "",
    releaseDate: "2026.8.14",
    image: require("../../assets/images/work/rm3_handful.avif"),
    price: null,
    tracklist: ["Handful of Keys", "Rose Room"],
    note: "",
    description: [
      "Ryu Muraki Threeによるシングルシリーズ・プロジェクト第1弾。",
      "トラディショナル・ジャズの歴史を築き上げた2人の偉大な音楽家にスポットを当て、時代を超えて愛され続けるジャズスタンダード・ナンバー2曲を収録。",
      "The first single in the Ryu Muraki Three series.",
      "This release spotlights two great musicians who helped shape the history of traditional jazz and features two jazz standards that continue to be loved across generations.",
    ],
    credits: [
      "Clarinet: 村木龍 Ryu Muraki",
      "Piano: 市川空 Sora Ichikawa",
      "Drums: 海老原颯 So Ebihara",
      "Engineer: 市川豪人 Taketo Ichikawa",
      "Artwork: 村木龍 Ryu Muraki",
    ],
    links: [
      {
        label: "配信で聴く",
        url: "https://ultravybe.lnk.to/HandfulofKeys",
      },
      {
        label: "Bandcampを見る",
        url: "https://ryumuraki.bandcamp.com/album/handful-of-keys",
      },
    ],
  },
];

const expandedMap = ref({});
const imageExpandedMap = ref({});
const collapseTimers = {};

const toggleExpanded = (id) => {
  const next = !expandedMap.value[id];
  expandedMap.value[id] = next;
  clearTimeout(collapseTimers[id]);

  if (next) {
    imageExpandedMap.value[id] = true;
  } else {
    // Delay shrinking the image back down until the text has finished
    // collapsing, otherwise it briefly stretches to the still-tall card.
    collapseTimers[id] = setTimeout(() => {
      imageExpandedMap.value[id] = false;
    }, 450);
  }
};

const shrinkTitle = ref(null);
const shrinkElement = ref(null);
onMounted(() => {
  window.addEventListener("scroll", shrinkTitleOnScroll);
  window.addEventListener("scroll", shrinkElementOnScroll);
});

const shrinkTitleOnScroll = () => {
  const element = shrinkTitle.value;
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    if (elementPosition - window.innerHeight <= -120) {
      element.classList.add("-show");
      window.removeEventListener("scroll", shrinkTitleOnScroll);
    }
  }
};
const shrinkElementOnScroll = () => {
  const element = shrinkElement.value;
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    if (elementPosition - window.innerHeight <= -120) {
      element.classList.add("-show");
      window.removeEventListener("scroll", shrinkElementOnScroll);
    }
  }
};
</script>

<template>
  <div class="discography" id="discography">
    <div class="background-content">
      <p class="background-left shrink-title -left" ref="shrinkTitle">DISCOGRAPHY</p>
    </div>
    <div class="discography-content shrink-element" ref="shrinkElement">
      <div class="album-list">
        <div
          class="album-card"
          v-for="album in albums"
          :key="album.id"
          :class="{ '-image-expanded': imageExpandedMap[album.id] }"
        >
          <a class="album-image" :href="album.links[0].url" target="_blank" rel="noopener">
            <img :src="album.image" :alt="album.title" />
          </a>

          <div class="album-info">
          <div class="album-header">
            <div class="avatar">RM3</div>
            <p class="username">ryumuraki3</p>
            <a class="ig-link" :href="igUrl" target="_blank" rel="noopener">
              <font-awesome-icon :icon="['fab', 'instagram']" class="fontawesome" />
            </a>
          </div>

          <div class="album-body">
            <p class="album-title">{{ album.title }}</p>
            <p class="album-meta">
              {{ [album.catalogNumber, album.label, album.releaseDate].filter(Boolean).join(" / ") }}
            </p>

            <div class="detail" :class="{ '-expanded': expandedMap[album.id] }">
              <div class="detail-inner">
                <ol class="tracklist">
                  <li v-for="(track, index) in album.tracklist" :key="index">{{ track }}</li>
                </ol>
                <p class="note" v-if="album.note">{{ album.note }}</p>

                <p class="price" v-if="album.price">価格：{{ album.price }}</p>

                <p class="description" v-for="(line, index) in album.description" :key="index">
                  {{ line }}
                </p>

                <p class="credit" v-for="(line, index) in album.credits" :key="index">
                  {{ line }}
                </p>
              </div>
              <div class="detail-fade" v-if="!expandedMap[album.id]"></div>
            </div>

            <button
              class="detail-toggle"
              :aria-label="expandedMap[album.id] ? '閉じる' : 'トラックリスト・詳細を見る'"
              @click="toggleExpanded(album.id)"
            >
              <font-awesome-icon
                :icon="['fas', 'chevron-down']"
                class="chevron"
                :class="{ '-flip': expandedMap[album.id] }"
              />
            </button>

            <div class="cta-group">
              <a
                class="cta"
                v-for="(linkItem, index) in album.links"
                :key="index"
                :href="linkItem.url"
                target="_blank"
                rel="noopener"
              >
                {{ linkItem.label }}
              </a>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" src="./style.scss" scoped></style>
